<ion-col class="double-monday-modal-root">
	<h1>{{ 'double_monday_modal.title' | translate }}</h1>
	<p>{{ 'double_monday_modal.description' | translate }}</p>
	<!-- <p>Hinweis: Sobald ein Double-Monday-Angebot gewählt wurde, profitieren auch weitere Bestellungen davon</p> -->
	<div class="button-container">
		<ion-button class="confirm-button" (click)="onConfirmClick()"> {{ 'double_monday_modal.confirm' | translate }} </ion-button>
		<ion-button class="decline-button" (click)="onDeclineClick()"> {{ 'double_monday_modal.decline' | translate }} </ion-button>
	</div>
</ion-col>
